import React, { useState, useEffect } from "react";

const TARGET = new Date("2026-06-08T07:30:00");

function getTimeLeft() {
  const diff = TARGET - new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

export default function CountdownTimer() {
  const [time, setTime] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => setTime(getTimeLeft()), 1000);
    return () => clearInterval(timer);
  }, []);

  const units = [
    { label: "Days", value: time.days },
    { label: "Hours", value: time.hours },
    { label: "Minutes", value: time.minutes },
    { label: "Seconds", value: time.seconds },
  ];

  return (
    <div
      className="grid grid-cols-4 gap-2 sm:flex sm:gap-3"
      data-testid="countdown-timer"
    >
      {units.map(({ label, value }) => (
        <div key={label} className="flex flex-col items-center">
          <div className="bg-white/95 rounded-lg w-full aspect-square sm:w-20 sm:h-20 flex items-center justify-center shadow">
            <span className="text-foreground font-bold text-2xl sm:text-3xl leading-none">
              {String(value).padStart(2, "0")}
            </span>
          </div>
          <span className="text-primary-foreground/80 text-xs sm:text-sm mt-1.5 font-medium">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
